import React from "react";

const LOGO_URL =
  "/images/luxelogo.png";

/**
 * Theme-aware Nisky Auto logo.
 * The source PNG has a residual black background; we drop it with
 * mix-blend-mode: screen in dark themes, and wrap it in a dark chip in
 * light themes so the marks always read cleanly.
 */
export default function Logo({ size = 32, className = "", glow = false }) {
  const px = `${size}px`;
  return (
    <span
      className={`inline-flex items-center justify-center rounded-lg shrink-0 transition-colors ${className}`}
      style={{ width: px, height: px }}
    >
      {/* In dark theme: transparent chip + screen blend. In light theme: dark chip behind logo. */}
      <span
        className="block w-full h-full rounded-lg bg-[#0b0b0b] dark:bg-transparent overflow-hidden"
        style={{
          boxShadow: glow
            ? "0 0 40px rgba(138,138,138,0.30), 0 0 12px rgba(170,170,170,0.4) inset"
            : undefined,
        }}
      >
        <img
          src={LOGO_URL}
          alt="Nisky Auto"
          className="w-full h-full object-contain dark:mix-blend-screen"
          style={{ filter: "contrast(1.08) brightness(1.08) saturate(1.1)" }}
        />
      </span>
    </span>
  );
}
